// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown {
  border-bottom: 1px solid #dee2e6;
  padding-top: 15px;
  padding-bottom: 10px;
}

.notif-tile {
  font-weight: bold;
}

a.dropdown-item:hover {
  background-color: #ced4da;
  cursor: pointer;
}

.styRead {
  background-color: transparent;
  font-weight: normal;
  color: black;
}

.styUnread {
  background-color: transparent;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.511);
}

.desc {
  font-size: 0.82rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
